import React from "react";

export default function ScheduleBtn() {
  return (
    <div className="text-white bg-black/80 sm:bg-black/90 w-full px-2 py-4 flex justify-between items-center sticky bottom-0">
      <div className="flex flex-col sm:flex-row justify-center items-center w-full">
        <span className="font-black-hawk text-2xl font-bold tracking-wider">
          <span className="text-red">ED</span>
          <span>GE 2</span>
          <span className="text-red">k2</span>
          <span>2 Re</span>
          <span className="text-red">sul</span>
          <span>ts : </span>
        </span>
        <span className="ml-2 text-lg border-2 border-[#7f0600] rounded-md px-2 py-1 mt-3 sm:mt-0">
          <a
            href="https://edge-results.s3.ap-south-1.amazonaws.com/EDGE'22+RESULTS.pdf"
            rel="noreferrer"
            target="_blank"
          >
            View Results
          </a>
        </span>
      </div>
    </div>
  );
}
